module.exports = __webpack_public_path__ + "frontend-assets/img/info_icon-hover.dd49110b.png";